var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDonation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8639 3.72852C6.47663 3.72852 3.72754 6.47761 3.72754 9.86488C3.72754 13.2522 6.47663 16.0012 9.8639 16.0012C13.2512 16.0012 16.0003 13.2522 16.0003 9.86488C16.0003 6.47761 13.2512 3.72852 9.8639 3.72852ZM10.4039 13.3994V14.1603H9.33004V13.3687C8.87595 13.2583 7.86345 12.8962 7.47686 11.5524L8.48936 11.1412C8.52618 11.2762 8.84527 12.4237 9.96208 12.4237C10.5328 12.4237 11.1771 12.1292 11.1771 11.4358C11.1771 10.8467 10.7475 10.5399 9.77799 10.1901C9.10299 9.95079 7.72231 9.55806 7.72231 8.15897C7.72231 8.09761 7.72845 6.68624 9.33004 6.34261V5.56942H10.4039V6.33033C11.533 6.5267 11.9441 7.42874 12.0362 7.69874L11.0666 8.10988C10.9991 7.89511 10.7046 7.28761 9.90072 7.28761C9.47118 7.28761 8.79004 7.51465 8.79004 8.14056C8.79004 8.72352 9.31777 8.94443 10.41 9.30647C11.8828 9.81579 12.2571 10.5644 12.2571 11.4235C12.2571 13.0374 10.723 13.3442 10.4039 13.3994Z",
    fill: "#199954"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonation);
export default __webpack_public_path__ + "static/media/donation.8edc8e58a86ddbb4370cefd5724dfc6f.svg";
export { ForwardRef as ReactComponent };